import { DropzoneWithErrors } from '@ff-os/shared-react/components/file-uploader/DropzoneWithErrors';
import { UploadError } from '@ff-os/shared-react/components/file-uploader/FileUploader';
import { createUploadMethod, UploadMethodsProps } from '@ff-os/shared-react/components/upload-methods/CreateUploadMethod';
import { maximumImageSize } from '@ff-os/shared-utils/constants/maximum-file-sizes';
import { noop } from 'lodash';
import { GiftDeviceUpload } from './GiftDeviceUpload';

export const createGiftUploadMethods = (props: GiftProps): UploadMethodsProps => {
    return {
        Dropzone: createUploadMethod(DropzoneWithErrors, {
            maxSize: maximumImageSize,
            accept: 'image/png, image/jpeg, image/bmp, image/heic, image/heif',
            onChange: props.dropzone.onChange,
            onError: noop,
            multiple: false,
            closeOnUpload: true,
            additionalErrors: props.dropzone.additionalErrors
        }),
        ExternalUpload: createUploadMethod(GiftDeviceUpload, {
            maxSize: maximumImageSize,
            accept: 'image/png, image/jpeg, image/bmp, image/heic, image/heif',
            onChange: noop,
            multiple: false,
            closeOnUpload: true,
            variableIds: props.externalUpload.variableIds
        })
    };
};

type GiftProps = {
    dropzone: {
        onChange: (files: File[]) => void;
        additionalErrors: UploadError[];
    };
    externalUpload: {
        variableIds: string[];
    };
};